import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';

import { CustomerCard } from './customer-card/customer-card.component';
import { InformationCard } from './information-card/information-card.component';

interface UserDetailsViewProps {
  user: GatewayUserModel;
}

export const UserDetailsView = ({
  user,
}: UserDetailsViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.M} direction="row">
      <InformationCard user={user} />
      <CustomerCard user={user} />
    </Stack>
  );
};
